import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { StoreService } from '../store.service';
import { CookieService } from 'ngx-cookie-service';
var LearningMapComponent = (function () {
    function LearningMapComponent(route, router, apiService, cookieService, commonService, storeService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.cookieService = cookieService;
        this.commonService = commonService;
        this.storeService = storeService;
        this.transBaseUrl = '';
        this.assetsRoute = '../../assets';
        this.progress = 0;
        this.isPC = false;
        this.isWxWork = false;
        this.haveBreakPoint = false;
        this.isVisitorToolsGuide = false;
        this.isHaveTools = false;
        this.circleTheme = {
            'width': 300,
            'height': 300,
            'x': 0,
            'y': 0,
            'radius': 90,
            'innerRadius': 20,
            'startAngle': 0,
            'endAngle': 360,
            'angleRadian': 275,
            'colors': ['#7E9FFB', '#5F81DB', '#60B68A', '#44976C', '#EEE'] //环形颜色
        }; //主题
        //客制化logo父盒子
        this.verticalLogoSize = [0, 0];
        this.customizeMetaInfo = {
            logoUrl: '',
            companyName: '',
            width: 0,
            height: 0
        };
        this.count = 0;
    }
    //客制化部分
    LearningMapComponent.prototype.fitLogoImgs = function (logoUrl) {
        var _this = this;
        // 获取设备宽度
        var deviceWidth = window.innerWidth;
        //上下结构的logo盒子宽
        var verticalLogoSize = this.verticalLogoSize = [
            80,
            // deviceWidth*.27,
            // deviceWidth*.45,
            80
        ];
        var v_ratio = verticalLogoSize[0] / verticalLogoSize[1];
        var newImg = document.createElement('img');
        newImg.style.display = 'none';
        newImg.onload = function () {
            var imgRatio = newImg.width / newImg.height;
            if (imgRatio < v_ratio) {
                _this.customizeMetaInfo.height = verticalLogoSize[1];
                _this.customizeMetaInfo.width = verticalLogoSize[1] * imgRatio;
            }
            else {
                _this.customizeMetaInfo.width = verticalLogoSize[0];
                _this.customizeMetaInfo.height = verticalLogoSize[0] / imgRatio;
            }
            _this.customizeMetaInfo.logoUrl = logoUrl;
        };
        newImg.src = logoUrl;
    };
    LearningMapComponent.prototype.getCustomizeMetaInfo = function () {
        var _this = this;
        this.apiService.getCustomizeMetaInfo().subscribe(function (res) {
            var logoUrl = res.logoUrl, title = res.title;
            _this.customizeMetaInfo.companyName = title;
            _this.fitLogoImgs(logoUrl);
        });
    };
    LearningMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        // 立即触发用户状态检查
        console.log('learning-map ngOnInit: 触发立即检查用户状态');
        this.storeService.notification.askImmediately.next(true);
        this.getCustomizeMetaInfo();
        // 清除项目相关信息
        localStorage.removeItem('projectmsg');
        localStorage.removeItem('projectId');
        // 清除训练营相关信息
        localStorage.removeItem('skuId');
        localStorage.removeItem('campId');
        //客制化开始
        $('#learningPathMetaIdContainer').val('');
        this.isHaveTools = localStorage.getItem('isHaveTools') ? JSON.parse(localStorage.getItem('isHaveTools')) : false;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.transBaseUrl = window['transBaseUrl'];
        this.isWxWork = this.commonService.isWxWork();
        //进入学地图时,各能力学习时长不计时
        localStorage.setItem('learningPathMetaId', '');
        this.companyMetaId = this.learningTour.tour_meta_id;
        // this.isPC = localStorage.getItem('isPC') ? true : false;
        this.isPC = !!localStorage.getItem('isPC');
        this.learningTour.projectList.forEach(function (item) {
            item.allCouseNum = Number(item.totalCourseNum ? item.totalCourseNum : 0) + Number(item.totalCampMetasNum ? item.totalCampMetasNum : 0);
            if (item.totalCampMetasNum && item.totalCampMetasNum == 1 && (!item.totalCourseNum || item.totalCourseNum == 0)) {
                item.isOnlyCampCourse = true;
                item.campMetasList[0].campOpenTime = item.campMetasList[0].preTestOpenTime ? self.tansFromTimestamp(item.campMetasList[0].preTestOpenTime, 1) : '';
            }
        });
        this.getUserBreakPoint().then(function (result) {
            _this.userBreakPoint = result;
            _this.haveBreakPoint = result.breakpointUrl && !localStorage.getItem('skuId') && !sessionStorage.getItem('userSession') && !result.breakpointUrl.includes('huatek');
            if (self.userBreakPoint.projectId) {
                self.getCourseitemsLock(_this.userBreakPoint.learningPathMetasId, _this.userBreakPoint.projectId).then(function (res) {
                    res.forEach(function (itm) {
                        var openAt = itm.openAt;
                        itm.openTime = openAt ? self.tansFromTimestamp(openAt, 1) : '';
                        itm.promptTime = openAt ? self.tansFromTimestamp(openAt, 2) : '';
                    });
                    localStorage.setItem('projectId', _this.userBreakPoint.projectId);
                    localStorage.setItem('projectmsg', JSON.stringify(res));
                });
            }
        }).then(function () {
            if (_this.isHaveTools) {
                _this.commonService.getOnceIno(99999).then(function (result) {
                    _this.isVisitorToolsGuide = result !== 1;
                });
            }
        }).then(function () {
            sessionStorage.setItem('userSession', _this.UserID);
            _this.setProgressInLearningTour();
        });
        // 获取项目列表
        // this.getProjectProgress().then(result => {
        //   let res = this.msgSort(result, 'projectCreateTime', 1)
        //   this.learningTour.projectList = res
        // });
    };
    LearningMapComponent.prototype.setPinpointPicture = function (id) {
        return 'https://ddileaf-uat-oss.oss-cn-shanghai.aliyuncs.com/scorm/pinpoint/' + encodeURIComponent(this.commonService.getPinpointCourseEnNameById(id).trim());
    };
    // 时间转化
    LearningMapComponent.prototype.tansFromTimestamp = function (timestamp, type) {
        var date = new Date(timestamp);
        var Y = date.getFullYear();
        var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        if (type == 1) {
            return M + "." + D;
        }
        else if (type == 2) {
            return Y + "-" + M + "-" + D + " " + h + ":" + m;
        }
    };
    //控制测,学,练,考是否锁住
    LearningMapComponent.prototype.getCourseitemsLock = function (learningPathMetaId, projectId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learningpathes/itemsLock/' + String(learningPathMetaId) + '?projectId=' + projectId,
        }).toPromise();
    };
    // 数组对象根据某个属性排序
    LearningMapComponent.prototype.msgSort = function (arr, name, type) {
        arr.sort(function (a, b) {
            // let t1 = new Date(a[name]);
            // let t2 = new Date(b[name]);
            // return t2.getTime() - t1.getTime();
            if (type == 1) {
                return b[name] < a[name] ? -1 : 1;
            }
            else {
                return b[name] > a[name] ? -1 : 1;
            }
        });
        return arr;
    };
    LearningMapComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': '#F2F3FA'
        });
    };
    //将进度数据插入learningTour
    LearningMapComponent.prototype.setProgressInLearningTour = function () {
        var _this = this;
        var learningPathMetas = this.learningTour.learning_path_metas;
        this.getUserLearningProgress().then(function (result) {
            _this.progressLists = result;
        }).then(function () {
            if (_this.progressLists.length !== 0) {
                _this.progressLists = _this.progressLists[_this.getIndexByConditionIdInLists(_this.progressLists, 'userId', _this.UserID)];
                var progressList = _this.progressLists['progressList'];
                for (var i = 0, len = learningPathMetas.length; i < len; i += 1) {
                    learningPathMetas[i].progress = 0;
                    if (progressList[_this.getIndexByConditionIdInLists(progressList, 'learningPathMetaId', learningPathMetas[i].id)] && learningPathMetas[i].id !== 22) {
                        learningPathMetas[i].progress = progressList[_this.getIndexByConditionIdInLists(progressList, 'learningPathMetaId', learningPathMetas[i].id)].progress;
                    }
                }
            }
            else {
                for (var i = 0, len = learningPathMetas.length; i < len; i += 1) {
                    learningPathMetas[i].progress = 0;
                }
            }
        });
    };
    //根据条件在数组中获取下标
    LearningMapComponent.prototype.getIndexByConditionIdInLists = function (Lists, condition, value) {
        return (Lists || []).findIndex(function (v) { return v[condition] === value; });
    };
    //获取用户学习断点
    LearningMapComponent.prototype.getUserBreakPoint = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'sr/breakpoint/getLastLearningbreakpoint'
        }).toPromise();
    };
    //获取用户进度
    LearningMapComponent.prototype.getUserLearningProgress = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress',
        }).toPromise();
    };
    //项目列表接口和项目学习进度接口
    // getProjectProgress(){
    //   return this.apiService.ajax({
    //     'type': 'GET',
    //     'url': 'ddilearner/v2/user/learning/projectProgress?needDetails=false',
    //   }).toPromise();
    // }
    //关闭断点
    LearningMapComponent.prototype.closeAppBreakPoint = function () {
        this.haveBreakPoint = false;
    };
    LearningMapComponent.prototype.goLearnPath = function (learningMetaId, version, name) {
        var link;
        if (Number(learningMetaId) > 5000 && Number(learningMetaId) < 6000) {
            this.router.navigate(['app-scorm', learningMetaId], { queryParams: { version: version, name: name } });
        }
        else {
            if (this.user_target) {
                link = ['app-experience', 'learning-path', learningMetaId];
            }
            else {
                link = ['learning-path', learningMetaId];
            }
            if (learningMetaId == 0) {
                this.commonService.setStorage('dnaReturnUrl', location.href);
                link = ['survey', this.learningTour.tour_id, 1, 2];
                this.router.navigate(link);
            }
            else if (learningMetaId == 22) {
                location.href = this.transBaseUrl + '/tr/checkUsers/' + this.UserID;
            }
            else {
                this.router.navigate(link);
            }
        }
    };
    // 进入项目课程页面
    LearningMapComponent.prototype.goProjectList = function (row) {
        var self = this;
        console.log(row, '010101');
        if (row.videoId) {
            self.router.navigate(['learning-project', row.projectId]);
        }
        else {
            //这里需要考虑有训练营的情况，就要减去DNA的数量，没有训练营的情况，就不用减去DNA的数量
            var courseLength = row.learningPathMetasDetailList.filter(function (item) { return item.learningPathMetaId !== 999; }).length;
            var campLength = row.campMetasList.length; //训练营的数量
            //进入项目旅程，这里包含过渡版DNA的逻辑，后面会改版
            if (!campLength //没有训练营，有课程 或者 没有训练营，有作业
                || campLength > 1 //有大于1个训练营
                || (campLength == 1 && (courseLength > 1 || row.totalHomeworkNum)) //有训练营，有大于1的课程(等于1的要单独判断是否是DNA，是的话，进训练营) 或者 有训练营，有作业
                || (campLength == 1 && (courseLength == 1 && (row.learningPathMetasDetailList[0].learningPathMetaId !== 0 && row.learningPathMetasDetailList[0].learningPathMetaId !== 999))) //有训练营，有1个课程，但不是DNA也不是小工具，进项目旅程
            ) {
                self.router.navigate(['learning-project', row.projectId]);
            }
            else {
                var skuId_1 = row.campMetasList[0].campMetasProjectId;
                var campId_1 = row.campMetasList[0].campMetasId;
                localStorage.setItem('skuId', skuId_1);
                localStorage.setItem('campId', campId_1);
                this.CoursesOrProjectCourses(row.projectId).then(function (res) {
                    self.commonService.setStorage('tourId', res.tour_id);
                    self.router.navigate(['learning-camp', skuId_1, campId_1]);
                });
            }
        }
    };
    LearningMapComponent.prototype.showVersion = function () {
        this.count++;
        if (this.count > 20) {
            var vConsole = new VConsole();
            this.count = 0;
        }
    };
    //获取项目下课程列表或者散客列表
    LearningMapComponent.prototype.CoursesOrProjectCourses = function (projectId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'sr/v2/coursesOrProjectCourses?projectId=' + projectId,
        }).toPromise();
    };
    return LearningMapComponent;
}());
export { LearningMapComponent };



// WEBPACK FOOTER //
// ./src/app/learning-map/learning-map.component.ts.pre-build-optimizer.js